import React from "react"

import { Helmet } from "react-helmet"
import { PRODMAP } from "../../../../utils/general"

const ProductOptionsSchema = (props) => {
  if (!props?.options?.length) {
    return null
  }
  const offers = props.options.map((option) => {
    return {
      "@type": "Offer",
      name: option.name || option.name_magento || option.option_title,
      description: option.text_description || option.description,
      //PMAX Google Shopping workaround via useOldPrice
      price:
        (!!props.useOldPrice && option.old_price) ||
        (!!props.useOldPrice && option.old_price_ui) ||
        option.price ||
        option.new_price ||
        option.old_price,
      sku: option.sku,
      priceCurrency: "USD",
      itemCondition: "https://schema.org/NewCondition",
      availability: "https://schema.org/InStock",
    }
  })

  const productID = offers[0]?.sku

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: props.meta_title || offers[0]?.name || PRODMAP[productID],
    description: offers[0]?.description,
    url: typeof window !== "undefined" ? window.location.href : "",
    image: props.options[0]?.image?.url || props.options[0]?.option_image?.url,
    brand: "Nutrafol",
    productID,
    offers,
  }

  //GTM uses alternateName so we need it on any page
  productSchema.alternateName = PRODMAP[productID] || productSchema.name

  return (
    <Helmet
      meta={[
        {
          name: "og:id",
          content: productID,
        },
        {
          name: "og:image_link",
          content: productSchema.image,
        },
        {
          name: "og:price",
          content: offers[0].price,
        },
        {
          name: "og:availability",
          content: "in stock",
        },
        {
          name: "og:link",
          content: productSchema.url,
        },
      ]}
    >
      <script type="application/ld+json">
        {JSON.stringify(productSchema)}
      </script>
    </Helmet>
  )
}

export default ProductOptionsSchema